/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* global console, document, Excel, Office */
// The initialize function must be run each time a new page is loaded
// eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
// import jwt_decode from "jwt-decode";s
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getFirestore, getDoc, updateDoc, doc, FieldPath } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyBE4jvTTaRNKN0iXNd_B_AP4Xrwl4EXqYs",
  authDomain: "dedupeone.firebaseapp.com",
  databaseURL: "https://dedupeone-default-rtdb.firebaseio.com",
  projectId: "dedupeone",
  storageBucket: "dedupeone.appspot.com",
  messagingSenderId: "939637555230",
  appId: "1:939637555230:web:615611b6fa04962e56ae0f",
  measurementId: "G-JDNL35CYD1",
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
Office.onReady(() => {
  // eslint-disable-next-line no-undef
  // if (localStorage.getItem("email")) {
  //   // eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
  //   var email = localStorage.getItem("email");
  //   document.getElementById("logged").innerHTML = "<p>User " + email + " Logged In</p>";
  //   document.getElementById("logged").style.fontSize = "16px";
  //   var logoutbtn = document.getElementById("logout");
  //   logoutbtn.classList.remove("hide");
  //   var loginbtn = document.getElementById("login");
  //   loginbtn.classList.add("hide");
  // }
  // eslint-disable-next-line no-undef
  var email = localStorage.getItem("email");
  if (document.getElementById("email")) document.getElementById("email").value = email;
  if (document.getElementById("sideload-msg")) document.getElementById("sideload-msg").style.display = "none";
  if (document.getElementById("app-body")) document.getElementById("app-body").style.display = "flex";
  // document.getElementById("login").onclick = getUserData;
  // document.getElementById("logout").onclick = logout;
  if (document.getElementById("emailbtn")) document.getElementById("emailbtn").onclick = emailsave;
  // eslint-disable-next-line no-undef
  localStorage.setItem("scfd", "");
  // eslint-disable-next-line no-undef
  localStorage.setItem("ss", false);
  // document.getElementById("t").onclick = test;
});
// eslint-disable-next-line no-undef
localStorage.setItem("scfd", "");
// eslint-disable-next-line no-undef
localStorage.setItem("ss", false);
// function todaydate() {
//   var today = new Date();
//   var dd = today.getDate();

//   var mm = today.getMonth() + 1;
//   var yyyy = today.getFullYear();
//   if (dd < 10) {
//     dd = "0" + dd;
//   }

//   if (mm < 10) {
//     mm = "0" + mm;
//   }
//   today = yyyy + "-" + mm + "-" + dd;
//   console.log(today);
//   return today;
// }
// function datecheck(subscrption_ending_date) {
//   var today = todaydate();
//   var timeremaining;
//   var today_date = new Date(today);
//   var subscription_end_date = new Date(subscrption_ending_date);
//   if (subscription_end_date.getTime() < today_date.getTime()) {
//     return (timeremaining = false);
//   } else if (subscription_end_date.getTime() > today_date.getTime()) {
//     return (timeremaining = true);
//   } else {
//     // eslint-disable-next-line @typescript-eslint/no-unused-vars
//     return (timeremaining = true);
//   }
// }
// async function test() {
//   try {
//     // eslint-disable-next-line no-undef
//     var email = localStorage.getItem("email");
//     // console.log(email);
//     var emailmatch;
//     var subscription_remaining;
//     const docRef = doc(db, "payments", "Excel");
//     const docSnap = await getDoc(docRef);
//     console.log(email);
//     const data = docSnap.data();
//     const emails = Object.keys(data);
//     const dates = Object.values(data);
//     // console.log(dates);
//     for (var i = 0; i < emails.length; i++) {
//       if (email == emails[i]) {
//         emailmatch = true;
//         for (var j = 0; j < dates.length; i++) {
//           subscription_remaining = datecheck(dates[i]);
//           break;
//         }
//         break;
//       } else {
//         emailmatch = false;
//         console.log(true);
//       }
//     }
//     if (emailmatch == true) {
//       if (subscription_remaining === true) {
//         console.log(true);
//       } else console.log(false);
//     }
//   } catch (exception) {
//     console.log(exception);
//   }
// }https://fuzzylookupforexcel.com/
// eslint-disable-next-line no-undef
if (!localStorage.getItem("tries")) {
  // eslint-disable-next-line no-undef
  localStorage.setItem("tries", "0");
}
async function emailsave() {
  try {
    // eslint-disable-next-line no-undef
    localStorage.setItem("scfd", "");
    // eslint-disable-next-line no-undef
    localStorage.setItem("ss", false);
    console.log("email here");
    var email = document.getElementById("email").value;
    // eslint-disable-next-line no-undef
    localStorage.setItem("email", email);
    //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // var email = "mailto:ghulam.mohayyuddin@analysis.eu";
    var d = new Date();
    d.setDate(d.getDate() - 1);
    // Get year, month, and day part from the date
    var year = d.toLocaleString("default", { year: "numeric" });
    var month = d.toLocaleString("default", { month: "2-digit" });
    var day = d.toLocaleString("default", { day: "2-digit" });

    // Generate yyyy-mm-dd date string
    var yesterday = year + "-" + month + "-" + day;
    console.log(yesterday);

    var email_match = null;
    const docRef = doc(db, "payments", "excelfuzzylookup");
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
    const emails = Object.keys(data);
    for (var i = 0; i < emails.length; i++) {
      if (email == emails[i]) {
        console.log("email matched");
        email_match = true;
        break;
      }
    }
    if (email_match !== true || email_match == null) {
      console.log("email not match");
      const fieldPath = new FieldPath(email);
      await updateDoc(docRef, fieldPath, yesterday);
      // eslint-disable-next-line no-undef
      console.log(localStorage.getItem("email"));
    }
    if (
      // eslint-disable-next-line no-undef
      localStorage.getItem("email") !== null &&
      // eslint-disable-next-line no-undef
      localStorage.getItem("email") !== undefined &&
      // eslint-disable-next-line no-undef
      localStorage.getItem("email") !== ""
    ) {
      // document.getElementById("msgemail").className += "alert-saved";
      var el = document.getElementById("msgemail");
      el.classList.add("alert-saved");
      document.getElementById("msgemail").innerHTML = "Email Saved";
    }
    // eslint-disable-next-line no-undef
    if (
      // eslint-disable-next-line no-undef
      localStorage.getItem("email") == null ||
      // eslint-disable-next-line no-undef
      localStorage.getItem("email") == undefined ||
      // eslint-disable-next-line no-undef
      localStorage.getItem("email") == ""
    ) {
      console.log("key");
      // document.getElementById("msgemail").classList.remove("alert-saved");
      var el2 = document.getElementById("msgemail");
      el2.classList.remove("alert-saved");
      document.getElementById("msgemail").innerHTML = "";
    }
  } catch (exception) {
    console.log(exception);
  }
}

// async function getUserData() {
//   try {
//     // eslint-disable-next-line no-undef
//     let userTokenEncoded = await OfficeRuntime.auth.getAccessToken({
//       allowConsentPrompt: true,
//       allowSignInPrompt: true,
//     });
//     let userToken = jwt_decode(userTokenEncoded);
//     console.log(userToken);
//     console.log(userToken.preferred_username); // email
//     // eslint-disable-next-line no-undef
//     localStorage.setItem("email", userToken.preferred_username);
//     console.log(userToken.oid); // user id
//     // eslint-disable-next-line no-undef
//     var email = localStorage.getItem("email");
//     document.getElementById("logged").innerHTML = "<p>User " + email + " Logged In</p>";
//     document.getElementById("logged").style.fontSize = "16px";
//     var logoutbtn = document.getElementById("logout");
//     logoutbtn.classList.remove("hide");
//     var loginbtn = document.getElementById("login");
//     loginbtn.classList.add("hide");
//     // eslint-disable-next-line @typescript-eslint/no-unused-vars
//     // var email = "ghulam.mohayyuddin@analysis.eu";
//     var yesterday = new Date();
//     var dd = yesterday.getDate() - 1;

//     var mm = yesterday.getMonth() + 1;
//     var yyyy = yesterday.getFullYear();
//     if (dd < 10) {
//       dd = "0" + dd;
//     }

//     if (mm < 10) {
//       mm = "0" + mm;
//     }
//     yesterday = yyyy + "-" + mm + "-" + dd;
//     console.log(yesterday);
//     const docRef = doc(db, "payments", "excelfuzzylookup");
//     const fieldPath = new FieldPath(userToken.preferred_username);
//     await updateDoc(docRef, fieldPath, yesterday);
//   } catch (exception) {
//     if (exception.code === 13003) {
//       console.log(
//         "SSO is not supported for domain user accounts, only Microsoft 365 Education or work account, or a Microsoft account."
//       );
//     } else {
//       console.log(exception);
//     }
//   }
// }
// async function logout() {
//   try {
//     // eslint-disable-next-line no-undef
//     localStorage.removeItem("email");
//     document.getElementById("logged").innerHTML = "";
//     var logoutbtn = document.getElementById("logout");
//     logoutbtn.classList.add("hide");
//     var loginbtn = document.getElementById("login");
//     loginbtn.classList.remove("hide");
//   } catch (exception) {
//     console.log(exception);
//   }
// }
export async function run() {
  try {
    await Excel.run(async (context) => {
      /**
       * Insert your Excel code here
       */
      const range = context.workbook.getSelectedRange();

      // Read the range address
      range.load("address");

      // Update the fill color
      range.format.fill.color = "yellow";

      await context.sync();
      console.log(`The range address was ${range.address}.`);
    });
  } catch (error) {
    console.error(error);
  }
}
